import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'st',
    fullName: 'Southern Sotho',
    nativeName: 'Sesotho',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Ho Hong ho Hlollang Ho Tla",
    landing_subtitle: "ArgVoid ke sesebelisoa sa ntlafatso sa papali le papali. Lula u mametse, lintho tse ncha lia tla haufinyane!",
    select_language: "Kgetha Puo",
    search_placeholder: "Batla lipuo...",
    terms_title: "Melao ea Ts'ebeletso",
    policy_title: "leano la lekunutu",
    cookies_title: "Leano la Cookie",
    terms_content: `
        <strong>1. Kamohelo ea Terms</strong><br>
        Ka ho kena ho ArgVoid, Melaoana ena ea Ts'ebeletso ea amoheloa. Haeba lipehelo tsena li sa lumellane, ts'ebeletso ha ea lokela ho sebelisoa.<br><br>

        <strong>2. Tšebeliso ea Sethala</strong>X<br>
        ArgVoid le lits'ebetso tsa eona li fanoe "joalo ka" molemong oa tlhaiso-leseling le oa boqapi. Ts'ebeletso e tlameha ho sebelisoa feela molemong oa molao.<br>X<br>

        <strong>3. Boitšoaro bo thibetsoeng</strong><br>
        Ho sebelisa hampe bofokoli ba sebaka, spamming, kapa ho leka ho kena lits'ebetsong ntle le tumello ho thibetsoe ka thata.<br><br>

        <strong>4. Boitlhotlhollo</strong><br>
        Sethala le litšebeletso li ka fetoloa ka nako efe kapa efe ntle le tsebiso. Ha ho na waranti e fanoeng mabapi le nako ea ts'ebeletso kapa boteng ba ts'ebeletso.
    `,
    policy_content: `
        <strong>1. Pokello ea Boitsebiso</strong><br>
        Sethala ha se hloke netefatso ea mosebelisi kapa ho theha ak'haonte ka nako ena. Ha ho lintlha tse khethollang motho (joalo ka mabitso kapa liaterese tsa lengolo-tsoibila) tse bokelloang ho tsoa ho baeti.<br><br>

        <strong>2. Lethathamo la lintlha tsa </strong>X<br>
        Litlhahlobo tsa mantlha, tse sa tsejoeng li ka bokelloa ho utloisisa sephethephethe sa sebaka le ho ntlafatsa lits'ebetso. Lintlha tsena ha lia amahanngoa le boitsebiso ba motho ka mong.<br>X<br>

        <strong>3. Litšebeletso tsa Mokha oa Boraro</strong><br>
        Bafani ba mekhatlo ea boraro ba ka sebelisoa bakeng sa lits'ebeletso tsa ho amohela le ho hlahloba. Mekhoa ea boinotši ea bafani bana ba fapaneng e laola boitsebiso bo sa tsejoeng bo sebetsitsoeng ho lisebelisoa tsa bona tsa motheo.<br><br>

        <strong>4. Tšireletso ea data</strong><br>
        Mehato e utloahalang ea ts'ireletso e kenngoa ts'ebetsong ho sireletsa sethala. Leha ho le joalo, ha ho mokhoa oa phetiso ka Marang-rang o bolokehileng ka botlalo.<br><br>
    `,
    cookies_content: `
        <strong>1. Li-cookie le Polokelo ea Lehae ke Eng?</strong><br>
        Li-cookies le polokelo ea lehae ea sebatli ke lifaele tse nyane tsa data tse bolokiloeng sesebelisoa ho hopola likhetho tsa tlhophiso ho pholletsa le maeto.<br><br>

        <strong>2. Tšebeliso ea Purpose</strong>X<br>
        Browser LocalStorage e sebelisoa ka thata ho boloka litlhophiso tsa tlhophiso, joalo ka:<br>
        - Likhetho tsa puo<br>
        - Tokiso ea sebopeho sa mosebelisi (mohlala, sebopeho kapa litlhophiso tsa sehlooho)<br>
        - Cache ea ts'ebeliso ea nakoana<br><br>

        <strong>3. Ha ho Tracking</strong><br>
        Li-cookie le polokelo ea lehae ha li sebelisetsoe ho bapatsa kapa ho latela batho ba bang. Lintlha tsohle tse bolokiloeng ke tsa ts'ebetso ea mantlha ea sethala.<br><br>

        <strong>4. Control</strong><br>
        Lintlha tsa sebatli li ka hlakoloa ka nako efe kapa efe ka litlhophiso tsa sebatli, tse tla hlophisa bocha litlhophiso tsa lehae.
    `,
    cookie_consent_text: "Re sebelisa li-cookies tsa mantlha ho netefatsa hore sebaka sa marang-rang se sebetsa ka nepo, joalo ka ho boloka nako ea hau e sebetsa, ho boloka puo eo u e ratang, le litlhophiso tse ling tsa tloaelo.",
    read_policy: "Bala Leano la Li-cookie",
    support_title: "Ikopanye le Tšehetso",
    support_subject_label: "Sehlooho",
    support_message_label: "Molaetsa",
    support_submit_button: "Romela Molaetsa",
    support_hint: "Tlhokomeliso: Sena se tla bula sesebelisoa sa hau sa kamehla sa lengolo-tsoibila ho romella molaetsa.",
    support_success_msg: "E bula sesebelisoa sa hau sa lengolo-tsoibila...",
    support_error_msg: "E hlolehile ho romela molaetsa. Ka kopo, leka hape hamorao.",
    explorer_title: "Mofuputsi",
    history_title: "Histori",
    animation_title: "Animation",
    config_title: "Tlhophiso",
    tool_mouse: "Khetha (Ctrl+M)",
    tool_brush: "Borashe (Ctrl+B)",
    tool_brush_mode: "Toggle Mode (Tiileng/Ho hlakile)",
    tool_eraser: "Raba (Ctrl+E)",
    tool_brush_size: "Fetola Boholo ba Brush",
    tool_bucket: "Tlatsa (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "Fetola (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Fetola V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "Bophara",
    label_height: "Bophahamo",
    label_frames: "Palo ea Liforeimi",
    label_animation: "Setaele sa Animation",
    label_background_color: "Mmala wa bokamorao",
    label_interval: "Karohano",
    tool_anim_config: "Animation Configuration",
    label_new_width: "Bophara bo Bocha",
    label_new_height: "Bophahamo bo Bocha",
    label_apply: "Etsa kopo",
    label_colors: "Mebala",
    label_size: "Boholo",
    label_tolerance: "Mamello",
    val_horizontal: "E tshekaletseng",
    val_vertical: "E otlolohileng",
    val_sequence: "Tatelano",
    val_bounce: "Qhoma",
    val_random: "Ka tšohanyetso",
    val_solid: "Tiileng",
    val_clear: "Hlakileng",
    action_add_sheet: "Leqephe le Lecha",
    action_import: "Kenya",
    action_export: "Export",
    action_sort_projects: "Hlopha",
    sort_date_old: "Ea Khale Pele",
    sort_date_new: "E Ncha Pele",
    sort_name_az: "Lebitso (A-Z)",
    sort_name_za: "Lebitso (Z-A)",
    action_new_sprite: "Sprite e ncha",
    action_new_project: "Morero o Mocha",
    modal_save_all_title: "Boloka Liphetoho Tsohle",
    modal_save_all_desc: "Khetha thepa eo u tla e boloka:",
    modal_save_selected: "Boloka E Khethiloeng",
    action_saved: "E bolokiloe",
    modal_create_sprite_title: "Theha Sprite e Ncha",
    modal_create_project_title: "Theha Morero o Mocha",
    modal_add_sheet_title: "Kenya Leqephe le Lecha",
    modal_rename_sheet_title: "Reha Letlapa hape",
    modal_rename_sprite_title: "Reha Sprite hape",
    modal_delete_sprite_title: "Hlakola Sprite",
    modal_delete_project_title: "Hlakola Project",
    modal_delete_sheet_title: "Hlakola Leqephe",
    placeholder_sprite_name: "Lebitso",
    placeholder_project_name: "Lebitso",
    placeholder_sheet_name: "Lebitso",
    placeholder_new_name: "Lebitso le Lecha",
    action_create: "Theha",
    action_add: "Eketsa",
    action_rename: "Reha lebitso bocha",
    action_duplicate: "Ea bobeli",
    action_delete: "Hlakola",
    action_cancel: "Hlakola",
    confirm_delete_sprite: "Na ehlile u batla ho hlakola sprite ee?",
    confirm_delete_project: "Na ehlile u batla ho hlakola morero oo? Li-sprites tsohle li tla tlosoa.",
    confirm_delete_sheet: "Na ehlile u batla ho hlakola leqephe lee?",
    err_select_sprite: "Ka kopo, khetha sprite pele.",
    err_select_project: "Ka kopo, khetha morero pele.",
    err_name_empty: "Lebitso le ka se hloke letho.",
    err_sprite_exists: "Sprite e nang le lebitso leo e se e ntse e le teng.",
    err_project_exists: "Morero o nang le lebitso leo o se o ntse o le teng.",
    err_no_content: "Ha ho litaba tse ka bolokoang.",
    err_no_changes: "Ha ho liphetoho tse lokelang ho bolokoa.",
    err_delete_last_sheet: "Ha e khone ho hlakola leqephe la ho qetela.",
    err_extract_frames: "Ha e khone ho ntša liforeimi leha e le life.",
    err_indexeddb: "E hlolehile ho boloka sebakeng sa heno. Sebatli sa hau se kanna sa hana ho ts'ehetsa IndexedDB.",
    msg_upload_success: "E atlehile ho Kenya: {0}",
    msg_upload_failed: "E hlolehile ho Kenya: {0}",
    msg_save_success: "E atlehile ho boloka.",
    msg_saving: "E boloka...",
    msg_multi_save_result: "E bolokiloe {0} thepa. {1} ho hloleha.",
    menu_title: "Lenane",
    menu_save: "Boloka",
    menu_save_all: "Boloka Tsohle",
    menu_support: "Ikopanye le Tšehetso",
    label_local_storage: "Polokelo ea Lehae",
    label_sign_in: "Kena",
    modal_export_title: "Export Sprite",
    label_filename: "Lebitso la faele",
    label_format: "Sebopeho",
    action_export_confirm: "Export",
};

export default translations;
